import { APICore } from "./apiCore";

const api = new APICore()

function listErights(params:any): any{
    const baseUrl = "/erights"
    return api.get(baseUrl,params)
}

function getEright(id:string): any{
    const baseUrl = `/erights/${id}`
    return api.get(baseUrl,{})
}

function addEright(params:any): any{
    const baseUrl=("/erights")
    return api.create(baseUrl,params)
}

function updateEright(params:any): any{
    const baseUrl=("/erights")
    return api.update(baseUrl,params)
}
function deleteEright(params:any): any{
    const baseUrl=("/erights")
    return api.delete(baseUrl,params)
}

export {listErights,getEright,addEright,updateEright,deleteEright}
